import React, { useState, useEffect } from "react";
import Style from "./Menu.module.css";
import { Link, useLocation } from "react-router-dom";

export default function Menu({setModalOpen}) {

    const [menuActive, setMenuActive] = useState(false);
    const location = useLocation();

    const toggleMenu = () => {
        setMenuActive(!menuActive);
    }

    // close menu on route change for mobile
    useEffect(() => {

        if (window.innerWidth < 768) {
            setTimeout(() => {
                setMenuActive(false);
            }, 500);
        }

    }, [location]);


    return (
        <div className={`${Style.menuCont} ${menuActive ? Style.menuActive : ''}`}>
            <div className={`${Style.menu} ${menuActive ? Style.menuActive : ''}`}>
                <nav>
                    <ul>
                        <li>
                            <Link to="/">Home</Link>
                        </li>
                        <li>
                            <Link to="/our-work">Our Work</Link>
                        </li>
                        <li>
                            <Link to="/solutions">Solutions</Link>
                        </li>
                        <li>
                            <Link to="/products">Products</Link>
                        </li>
                        {/* <li>
                            <Link to="/about">About</Link>
                        </li> */}
                        <li>
                            <a onClick={() => setModalOpen('contact-form')}>Contact</a>
                        </li>
                        <li>
                            <a href="https://www.linkedin.com/company/gnarsoftware" target="_blank" rel="noreferrer">
                                <img src={require('../../assets/linkedIn_icon.svg').default} alt="linkedin" className={Style.socialIcon} />
                            </a>
                        </li>
                        <li onClick={toggleMenu}>
                            <img src={require('../../assets/close_cross.svg').default} alt="close" className={Style.burgerClose} />
                        </li>
                    </ul>
                </nav>            
            </div>
            <div className={menuActive ? Style.burgerCont : Style.burgerContActive} onClick={toggleMenu}>
                <img src={require('../../assets/burger_menu.svg').default} alt="" className={Style.burger} />
            </div>
        </div>
    );
}